import { createContext, use } from 'react';
import { type ToastProperties } from '@/common/components/ToastContainer';

export const ToastContext = createContext<(_: ToastProperties) => void>(() => {
  /* do nothing */
});

export const useToast = (): ((_: ToastProperties) => void) => {
  return use(ToastContext);
};
